import { render, staticRenderFns } from "./CompletedRevs.vue?vue&type=template&id=444d8a26&scoped=true"
import script from "./CompletedRevs.vue?vue&type=script&lang=js"
export * from "./CompletedRevs.vue?vue&type=script&lang=js"
import style0 from "./CompletedRevs.vue?vue&type=style&index=0&id=444d8a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444d8a26",
  null
  
)

export default component.exports